<template>
  <div>
    <v-app-bar app color="white" elevation="4">
      <v-app-bar-nav-icon @click.stop="toggleDrawerMobile()"></v-app-bar-nav-icon>
      <!-- ตั้งค่าประเภทบัญชี -->
      <div v-for="(dashboardList, index) in dashboardList" :key="`dashboard-${index}-${dashboardList.path}`">
        <v-toolbar-title class="mr-3" v-if="$route.path == dashboardList.path">
          <router-link class="link_menu" to="/arin" exact>
            <div class="nav-header" :class="{ 'active': $route.path == dashboardList.active }">
              <div class="nav-menu">
                <div class="nav-items">
                  <span class="nav-item-title">Dashboard</span>
                </div>
              </div>
            </div>
          </router-link>
        </v-toolbar-title>
      </div>
      <!-- รายการสมาชิก -->
      <div v-for="adminList in adminList" :key="adminList.path">
        <v-toolbar-title class="mr-3" v-if="$route.name == adminList.path">
          <router-link class="link_menu" to="/arin/adminlist" exact>
            <div class="nav-header" :class="{ 'active': $route.name == adminList.active }">
              <div class="nav-menu">
                <div class="nav-items">
                  <span class="nav-item-title">ทีมงาน</span>
                </div>
              </div>
            </div>
          </router-link>
        </v-toolbar-title>
      </div>
      <div v-if="this.$store.state.store_arin.status_permission == 1">
        <div v-for="(adminProfile, index) in adminProfile" :key="`adminProfile-${index}-${adminProfile.path}`">
          <v-toolbar-title class="mr-3" v-if="$route.path == adminProfile.path">
            <router-link class="link_menu" to="/arin/adminlist/adminprofile" exact>
              <div class="nav-header" :class="{ 'active': $route.path == adminProfile.active }">
                <div class="nav-menu">
                  <div class="nav-items">
                    <span class="nav-item-title">ข้อมูลส่วนตัว</span>
                  </div>
                </div>
              </div>
            </router-link>
          </v-toolbar-title>
        </div>
      </div>

      <!-- ตั้งค่าประเภทบัญชี -->
      <div v-for="accountsetting in accountsetting" :key="accountsetting.path">
        <v-toolbar-title class="mr-3" v-if="$route.path == accountsetting.path">
          <router-link class="link_menu" to="/arin/accountsetting/setting" exact>
            <div class="nav-header" :class="{ 'active': $route.path == '/arin/accountsetting/setting' }">
              <div class="nav-menu">
                <div class="nav-items">
                  <span class="nav-item-title">ตั้งค่าประเภทบัญชี</span>
                </div>
              </div>
            </div>
          </router-link>
        </v-toolbar-title>
      </div>
      <div v-for="(accounthistory, index) in accounthistory" :key="`accounthistory-${index}-${accounthistory.path}`">
        <v-toolbar-title class="mr-3" v-if="$route.path == accounthistory.path">
          <router-link class="link_menu" to="/arin/accountsetting/accounthistory" exact>
            <div class="nav-header" :class="{ 'active': $route.path == '/arin/accountsetting/accounthistory' }">
              <div class="nav-menu">
                <div class="nav-items">
                  <span class="nav-item-title">บันทึกบัญชี</span>
                </div>
              </div>
            </div>
          </router-link>
        </v-toolbar-title>
      </div>
      <!-- POS -->

      <!-- ออกใบสั่งซื้อ -->
      <div v-for="(pos_system, index) in pos_system" :key="`pos_system-${index}-${pos_system.path || pos_system.path_id || index}`">
        <!-- {{ pos_system.path_id }} -->
        <v-toolbar-title class="mr-3" v-if="$route.path == pos_system.path || $route.name == pos_system.path_id">
          <v-menu open-on-click offset-y>
            <template v-slot:activator="{ on, attrs }">
              <div class="nav-header" v-bind="attrs" v-on="on"
                :class="{ 'active': $route.path == pos_system.active || $route.name == pos_system.active_id }">
                <div class="nav-menu">
                  <div class="nav-items">
                    <span class="nav-item-title">ออกใบสั่งซื้อ</span>
                  </div>
                </div>
              </div>
            </template>

            <v-list>
              <v-list-item-title v-for="(itemsProduct, i) in itemsProduct" :key="`itemsProduct-${i}-${itemsProduct.href}`" class="py-3 px-3"
                style="cursor: pointer;" @click="switch_page(itemsProduct.href)">{{
                  itemsProduct.menu
                }}</v-list-item-title>
            </v-list>
          </v-menu>
        </v-toolbar-title>
      </div>


      <!-- คลังสินค้า -->
      <div v-for="(warehouse, index) in warehouse" :key="`warehouse-${index}-${warehouse.path || warehouse.path_id || index}`">
        <v-toolbar-title class="mr-3" v-if="$route.path == warehouse.path || $route.name == warehouse.path_id">
          <v-menu open-on-click offset-y>
            <template v-slot:activator="{ on, attrs }">
              <div class="nav-header" v-bind="attrs" v-on="on"
                :class="{ 'active': $route.path == warehouse.active || $route.name == warehouse.active_id }">
                <div class="nav-menu">
                  <div class="nav-items">
                    <span class="nav-item-title">คลังสินค้า</span>
                  </div>
                </div>
              </div>
            </template>

            <v-list class="">
              <v-list-tile-title>
                <v-menu open-on-hover right offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-title class="py-3 px-3" v-bind="attrs" v-on="on">สินค้า</v-list-item-title>
                  </template>
                  <v-list>
                    <v-list-item v-for="(sub_warehouse_product, i) in sub_warehouse_product" :key="`sub_warehouse_product-${i}-${sub_warehouse_product.href}`">
                      <v-list-item-title style="cursor: pointer;" @click="switch_page(sub_warehouse_product.href)">{{
                        sub_warehouse_product.menu
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-tile-title>
              <v-list-tile-title>
                <v-menu open-on-hover right offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-title class="py-3 px-3" v-bind="attrs" v-on="on">คลัง</v-list-item-title>
                  </template>
                  <v-list>
                    <v-list-item v-for="(sub_warehouse_stockProduct, index) in sub_warehouse_stockProduct" :key="`sub_warehouse_stockProduct-${index}-${sub_warehouse_stockProduct.href}`">
                      <v-list-item-title style="cursor: pointer;" @click="switch_page(sub_warehouse_stockProduct.href)">{{
                        sub_warehouse_stockProduct.menu
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-tile-title>
              <v-list-item-title class="py-3 px-3" style="cursor: pointer;"
                @click="switch_page('/arin/pos/countingstocklist')">การนับสต๊อก</v-list-item-title>
              <v-list-item-title class="py-3 px-3" style="cursor: pointer;"
                @click="switch_page('/arin/pos/inventoryreport')">รายงานสรุปคลังสินค้า</v-list-item-title>
            </v-list>
          </v-menu>
        </v-toolbar-title>
      </div>

      <!-- การขาย -->
      <div v-for="(pos_sale, index) in pos_sale" :key="`pos_sale-${index}-${pos_sale.path || pos_sale.path_id || index}`">
        <v-toolbar-title class="mr-3" v-if="$route.path == pos_sale.path || $route.name == pos_sale.path_id">
          <v-menu open-on-click offset-y>
            <template v-slot:activator="{ on, attrs }">
              <div class="nav-header" v-bind="attrs" v-on="on"
                :class="{ 'active': $route.path == pos_sale.active || $route.path == pos_sale.active_id }">
                <div class="nav-menu">
                  <div class="nav-items">
                    <span class="nav-item-title">การขาย</span>
                  </div>
                </div>
              </div>
            </template>

            <v-list>
              <v-list-item-title class="py-3 px-3" v-for="(pos_sub_sale, i) in pos_sub_sale" :key="`pos_sub_sale-${i}-${pos_sub_sale.href}`"
                style="cursor: pointer;" @click="switch_page(pos_sub_sale.href)">{{
                  pos_sub_sale.menu
                }}</v-list-item-title>
            </v-list>
          </v-menu>
        </v-toolbar-title>
      </div>



      <!-- การสะสมแต้มลูกค้า -->
      <div v-for="(pos_collection_of_points, index) in pos_collection_of_points" :key="`pos_collection_of_points-${index}-${pos_collection_of_points.path || pos_collection_of_points.path_id || index}`">
        <v-toolbar-title class="mr-3"
          v-if="$route.path == pos_collection_of_points.path || $route.name == pos_collection_of_points.path_id">
          <router-link class="link_menu" to="/arin/pos/customerpointlist" exact>
            <div class="nav-header"
              :class="{ 'active': $route.path == pos_collection_of_points.active || $route.name == pos_collection_of_points.active_id }">
              <div class="nav-menu">
                <div class="nav-items">
                  <span class="nav-item-title">การสะสมแต้มลูกค้า</span>
                </div>
              </div>
            </div>
          </router-link>
        </v-toolbar-title>
      </div>
      <!-- ตั้งค่าเว็บไซต์ -->
      <div v-for="(websitesetting, index) in websitesetting" :key="`websitesetting-${index}-${websitesetting.path}`">
        <v-toolbar-title class="mr-3" v-if="$route.path == websitesetting.path">
          <router-link class="link_menu" to="/arin/setting" exact>
            <div class="nav-header" :class="{ 'active': $route.path.substring(1).split('/')[1] == 'setting' }">
              <div class="nav-menu">
                <div class="nav-items">
                  <span class="nav-item-title">ตั้งค่าเว็บไซต์</span>
                </div>
              </div>
            </div>
          </router-link>
        </v-toolbar-title>
      </div>

      <v-spacer></v-spacer>
      <div class="profile_user pt-1 mx-auto cursor_pointer">
        <img style="border-radius: 25px;" v-if="this.$store.state.store_arin.user_data.picture"
          :src="this.$store.state.store_arin.user_data.picture">
        <img v-else src="@/assets/arin_assets/logo_user.png">
      </div>
      <div class="user_account text-left pl-3" @click="logout()">
        <div class="user_name">{{ this.$store.state.store_arin.user_data.name }}</div>

        <div class="user_role" v-if="this.$store.state.store_arin.status_permission == 0">Admin</div>
        <div class="user_role" v-else>{{ this.$store.state.store_arin.user_data.claim_status == 0 ? 'Admin' : 'Employee'
        }}</div>

      </div>
    </v-app-bar>
    <v-navigation-drawer app v-model="drawer" class="navigation_bg pc" width="84" permanent
      :style="{ backgroundColor: input_set.store_color }">
      <v-list-item class="menu-logo">
        <v-list-item-content class="border-bottom-logo">

          <v-card elevation="4" class="card_logo" v-if="input_set.logo_pos == null">
            <div class="logo_list">
              <div class="logo">
                <img src="@/assets/arin_assets/logo_main.png" alt="logo" width="36" height="36">
              </div>
            </div>
          </v-card>

          <div class=" pt-1 mx-auto cursor_pointer" v-else style="max-weight:52px;">
            <img style="border-radius: 25px;" :src="input_set.logo_pos" width="52" height="52">
          </div>
        </v-list-item-content>
      </v-list-item>

      <div>
        <!-- DASHBOARD MENU -->
        <v-list-item class="meun-list" exact :class="{ 'router-link-active': $route.path == '/arin' }"
          v-if="input_set.store_name != null">
          <v-list-item-content class="">
            <router-link to="/arin">
              <v-card elevation="4" class="card_logo">
                <div class="logo_list">
                  <div class="logo">
                    <img src="@/assets/arin_assets/graph_color.png">
                  </div>
                </div>
              </v-card>
            </router-link>
          </v-list-item-content>
        </v-list-item>
        <!-- CUSTOMER MENU -->
        <v-list-item class="meun-list" exact v-if="input_set.store_name != null"
          :class="{ 'router-link-active': $route.path == '/arin/adminlist' || $route.path == '/arin/adminlist/addemployee' || $route.name == 'detailemployee' || $route.path == '/arin/adminlist/adminprofile' || $route.name == 'editemployee' }">
          <v-list-item-content>
            <router-link to="/arin/adminlist">
              <v-card elevation="4" class="card_logo">
                <div class="logo_list">
                  <div class="logo">
                    <img src="@/assets/arin_assets/avatar_profile.png" alt="">
                  </div>
                </div>
              </v-card>
            </router-link>
          </v-list-item-content>
        </v-list-item>
        <!-- POS MENU -->
        <v-list-item class="meun-list" exact v-if="input_set.store_name != null"
          :class="{ 'router-link-active': $route.path == '/arin/pos/productlist' || $route.path == '/arin/pos/cartlist' || $route.path == '/arin/pos/myorderlist' || $route.path == '/arin/pos/inventoryreport' || $route.path == '/arin/pos/customerpointlist' || $route.path == '/arin/pos/addcustomerpoint' || $route.path == '/arin/pos/detailcustomerpoint' || $route.path == '/arin/pos/manageservice' || $route.path == '/arin/pos/warehouseproductlist' || $route.path == '/arin/pos/addproductdata' || $route.name == 'editproductdata' || $route.name == 'editproductservice' || $route.name == 'detailproductdata' || $route.path == '/arin/pos/printbarcode' || $route.path == '/arin/pos/countingstocklist' || $route.path == '/arin/pos/addproductservice' || $route.path == '/arin/pos/chooseproduct' || $route.path == '/arin/pos/promotionlist' || $route.path == '/arin/pos/addpromotion' || $route.path == '/arin/pos/addpromotionnew' || $route.path == '/arin/pos/inventorylist' || $route.path == '/arin/pos/stocksearch' || $route.path == '/arin/pos/historyimportinventory' || $route.path == '/arin/pos/promotioncreate' || $route.path == '/arin/pos/promotioncreatenew' || $route.path == '/arin/pos/productempty' || $route.path == '/arin/pos/countingstocklist' || $route.path == '/arin/pos/countingstockcheck' || $route.path == '/arin/pos/countingstockcreate' || $route.path == '/arin/pos/countingstockdetail/' + $route.params.id || $route.path == '/arin/pos/countingstockcount' || $route.path == '/arin/pos/productSettinglist' || $route.path == '/arin/pos/addproductdata' || $route.name == 'detailproductdata' || $route.name == 'editpromotion' || $route.name == 'detailpromotion' || $route.path == '/arin/pos/editposSupplier/' + $route.params.id || $route.path == '/arin/pos/openpos' || $route.path == '/arin/pos/posbillafter' || $route.path == '/arin/pos/posinvoicestax' || $route.path == '/arin/pos/posinvoicestaxrefund' || $route.path == '/arin/pos/posinvoicestaxrefundadd' || $route.path == '/arin/pos/posinvoicestaxrefundadd/' + this.$route.params.id || $route.path == '/arin/pos/posinvoicestaxrefundedit/' + this.$route.params.id || $route.path == '/arin/pos/posinvoicestaxrefunddetail/' + this.$route.params.id || $route.path == '/arin/pos/posinvoicestaxadd' || $route.path == '/arin/pos/posinvoicestaxadd/' + $route.params.id || $route.path == '/arin/pos/posinvoicestaxdetail/' + $route.params.id || $route.path == '/arin/pos/possalereport' || $route.path == '/arin/pos/possalereportround/' + $route.params.id || $route.path == '/arin/pos/inventoryadd' || $route.name == 'historyimportinventorydetail' || $route.path == '/arin/pos/posbillsale/' + $route.params.id || $route.path == '/arin/pos/countingstockedit/' + $route.params.id || $route.path == 'arin/pos/posrecallbill/' + $route.params.id || $route.path == '/arin/pos/posinvoicesclosesummary/' + $route.params.id  || $route.path == '/arin/pos/AddposSupplier' || $route.path == '/arin/pos/posSupplier' || $route.path == '/arin/pos/editposSupplier/'+ $route.params.id || $route.path == '/arin/pos/posdebtbalancelist' || $route.path == '/arin/pos/posdebtbalancepayhistory' || $route.path == '/arin/pos/posdebtbalancedetail' || $route.path == '/arin/pos/posdebtbalancepay' || $route.path == '/arin/pos/posdebtbalancepaybank' || $route.path == '/arin/pos/possalehistory'}">
          <v-list-item-content>
            <router-link to="/arin/pos/productlist">
              <v-card elevation="4" class="card_logo">
                <div class="logo_list">
                  <div class="logo">
                    <img src="@/assets/arin_assets/cashier.png" alt="">
                  </div>
                </div>
              </v-card>
            </router-link>
          </v-list-item-content>
        </v-list-item>
        <!-- ACCOUNTING MENU -->
        <v-list-item class="meun-list" exact v-if="input_set.store_name != null"
          :class="{ 'router-link-active': $route.path.substring(1).split('/')[1] == 'accountsetting' }">
          <v-list-item-content>
            <router-link to="/arin/accountsetting/setting">
              <v-card elevation="4" class="card_logo">
                <div class="logo_list">
                  <div class="logo">
                    <img src="@/assets/arin_assets/accounting_color.png" alt="">
                  </div>
                </div>
              </v-card>
            </router-link>
          </v-list-item-content>
        </v-list-item>

        <!-- SETTING WEBSITE -->
        <v-list-item class="meun-list" exact :class="{ 'router-link-active': $route.path == '/arin/setting' }">
          <v-list-item-content>
            <router-link to="/arin/setting">
              <v-card elevation="4" class="card_logo">
                <div class="logo_list">
                  <div class="logo">
                    <img src="@/assets/arin_assets/cms.png" alt="">
                  </div>
                </div>
              </v-card>
            </router-link>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer app v-model="drawerMobile" class="navigation_bg" width="84" temporary
    style="z-index: 999;"
      :style="{ backgroundColor: input_set.store_color }">
      <v-list-item class="menu-logo">
        <v-list-item-content class="border-bottom-logo">

          <v-card elevation="4" class="card_logo" v-if="input_set.logo_pos == null">
            <div class="logo_list">
              <div class="logo">
                <img src="@/assets/arin_assets/logo_main.png" alt="logo" width="36" height="36">
              </div>
            </div>
          </v-card>

          <div class=" pt-1 mx-auto cursor_pointer" v-else style="max-weight:52px;">
            <img style="border-radius: 25px;" :src="input_set.logo_pos" width="52" height="52">
          </div>
        </v-list-item-content>
      </v-list-item>

      <div>
        <!-- DASHBOARD MENU -->
        <v-list-item class="meun-list" exact :class="{ 'router-link-active': $route.path == '/arin' }"
          v-if="input_set.store_name != null">
          <v-list-item-content class="">
            <router-link to="/arin">
              <v-card elevation="4" class="card_logo">
                <div class="logo_list">
                  <div class="logo">
                    <img src="@/assets/arin_assets/graph_color.png">
                  </div>
                </div>
              </v-card>
            </router-link>
          </v-list-item-content>
        </v-list-item>
        <!-- CUSTOMER MENU -->
        <v-list-item class="meun-list" exact v-if="input_set.store_name != null"
          :class="{ 'router-link-active': $route.path == '/arin/adminlist' || $route.path == '/arin/adminlist/addemployee' || $route.name == 'detailemployee' || $route.path == '/arin/adminlist/adminprofile' || $route.name == 'editemployee' }">
          <v-list-item-content>
            <router-link to="/arin/adminlist">
              <v-card elevation="4" class="card_logo">
                <div class="logo_list">
                  <div class="logo">
                    <img src="@/assets/arin_assets/avatar_profile.png" alt="">
                  </div>
                </div>
              </v-card>
            </router-link>
          </v-list-item-content>
        </v-list-item>
        <!-- POS MENU -->
        <v-list-item class="meun-list" exact v-if="input_set.store_name != null"
          :class="{ 'router-link-active': $route.path == '/arin/pos/productlist' || $route.path == '/arin/pos/cartlist' || $route.path == '/arin/pos/myorderlist' || $route.path == '/arin/pos/inventoryreport' || $route.path == '/arin/pos/customerpointlist' || $route.path == '/arin/pos/addcustomerpoint' || $route.path == '/arin/pos/detailcustomerpoint' || $route.path == '/arin/pos/manageservice' || $route.path == '/arin/pos/warehouseproductlist' || $route.path == '/arin/pos/addproductdata' || $route.name == 'editproductdata' || $route.name == 'editproductservice' || $route.name == 'detailproductdata' || $route.path == '/arin/pos/printbarcode' || $route.path == '/arin/pos/countingstocklist' || $route.path == '/arin/pos/addproductservice' || $route.path == '/arin/pos/chooseproduct' || $route.path == '/arin/pos/promotionlist' || $route.path == '/arin/pos/addpromotion' || $route.path == '/arin/pos/addpromotionnew' || $route.path == '/arin/pos/inventorylist' || $route.path == '/arin/pos/stocksearch' || $route.path == '/arin/pos/historyimportinventory' || $route.path == '/arin/pos/promotioncreate' || $route.path == '/arin/pos/promotioncreatenew' || $route.path == '/arin/pos/productempty' || $route.path == '/arin/pos/countingstocklist' || $route.path == '/arin/pos/countingstockcheck' || $route.path == '/arin/pos/countingstockcreate' || $route.path == '/arin/pos/countingstockdetail/' + $route.params.id || $route.path == '/arin/pos/countingstockcount' || $route.path == '/arin/pos/productSettinglist' || $route.path == '/arin/pos/addproductdata' || $route.name == 'detailproductdata' || $route.name == 'editpromotion' || $route.name == 'detailpromotion' || $route.path == '/arin/pos/editposSupplier/' + $route.params.id || $route.path == '/arin/pos/openpos' || $route.path == '/arin/pos/posbillafter' || $route.path == '/arin/pos/posinvoicestax' || $route.path == '/arin/pos/posinvoicestaxrefund' || $route.path == '/arin/pos/posinvoicestaxrefundadd' || $route.path == '/arin/pos/posinvoicestaxrefundadd/' + this.$route.params.id || $route.path == '/arin/pos/posinvoicestaxrefundedit/' + this.$route.params.id || $route.path == '/arin/pos/posinvoicestaxrefunddetail/' + this.$route.params.id || $route.path == '/arin/pos/posinvoicestaxadd' || $route.path == '/arin/pos/posinvoicestaxadd/' + $route.params.id || $route.path == '/arin/pos/posinvoicestaxdetail/' + $route.params.id || $route.path == '/arin/pos/possalereport' || $route.path == '/arin/pos/possalereportround/' + $route.params.id || $route.path == '/arin/pos/inventoryadd' || $route.name == 'historyimportinventorydetail' || $route.path == '/arin/pos/posbillsale/' + $route.params.id || $route.path == '/arin/pos/countingstockedit/' + $route.params.id || $route.path == 'arin/pos/posrecallbill/' + $route.params.id || $route.path == '/arin/pos/posinvoicesclosesummary/' + $route.params.id  || $route.path == '/arin/pos/AddposSupplier' || $route.path == '/arin/pos/posSupplier' || $route.path == '/arin/pos/editposSupplier/'+ $route.params.id || $route.path == '/arin/pos/posdebtbalancelist' || $route.path == '/arin/pos/posdebtbalancepayhistory' || $route.path == '/arin/pos/posdebtbalancedetail' || $route.path == '/arin/pos/posdebtbalancepay' || $route.path == '/arin/pos/posdebtbalancepaybank' || $route.path == '/arin/pos/possalehistory'}">
          <v-list-item-content>
            <router-link to="/arin/pos/productlist">
              <v-card elevation="4" class="card_logo">
                <div class="logo_list">
                  <div class="logo">
                    <img src="@/assets/arin_assets/cashier.png" alt="">
                  </div>
                </div>
              </v-card>
            </router-link>
          </v-list-item-content>
        </v-list-item>
        <!-- ACCOUNTING MENU -->
        <v-list-item class="meun-list" exact v-if="input_set.store_name != null"
          :class="{ 'router-link-active': $route.path.substring(1).split('/')[1] == 'accountsetting' }">
          <v-list-item-content>
            <router-link to="/arin/accountsetting/setting">
              <v-card elevation="4" class="card_logo">
                <div class="logo_list">
                  <div class="logo">
                    <img src="@/assets/arin_assets/accounting_color.png" alt="">
                  </div>
                </div>
              </v-card>
            </router-link>
          </v-list-item-content>
        </v-list-item>

        <!-- SETTING WEBSITE -->
        <v-list-item class="meun-list" exact :class="{ 'router-link-active': $route.path == '/arin/setting' }">
          <v-list-item-content>
            <router-link to="/arin/setting">
              <v-card elevation="4" class="card_logo">
                <div class="logo_list">
                  <div class="logo">
                    <img src="@/assets/arin_assets/cms.png" alt="">
                  </div>
                </div>
              </v-card>
            </router-link>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-navigation-drawer>
  </div>
</template>


<script>
import Swal from "sweetalert2";
import { HTTP_ARIN } from "@/axios_arin";

export default {
  name: "ArinMenu",
  data() {
    return {
      // ผู้ดูแลระบบ
      drawer: null, // ใช้ควบคุมเปิด-ปิดเมนู
      drawerMobile: null, // ใช้ควบคุมเปิด-ปิดเมนูมือถือ
      dashboardList: [
        { path: '/arin', active: '/arin' },
      ],
      // ผู้ดูแลระบบ
      adminList: [
        { path: 'adminlist', active: 'adminlist' },
        { path: 'adminprofile' },
        { path: 'detailemployee', active: 'detailemployee' },
        { path: 'addemployee', active: 'addemployee' },
        { path: 'editemployee', active: 'editemployee' },
      ],
      // ข้อมูลส่วนตัว
      adminProfile: [
        { path: '/arin/adminlist' },
        { path: '/arin/adminlist/adminprofile', active: '/arin/adminlist/adminprofile' },
        { path: '/arin/adminlist/detailemployee' },
        { path: '/arin/adminlist/addemployee' },
      ],
      // เมนูตั้งค่าบัญชี
      accountsetting: [
        { path: '/arin/accountsetting/setting', active: '/arin/accountsetting/setting' },
        { path: '/arin/accountsetting/accounthistory' },
      ],
      // เมนูบันทึกบัญชี
      accounthistory: [
        { path: '/arin/accountsetting/accounthistory', active: '/arin/accountsetting/accounthistory' },
        { path: '/arin/accountsetting/setting' },
      ],
      // เมนูตั้งค่าเว็บไซต์
      websitesetting: [
        { path: '/arin/setting', active: '/arin/setting' },

      ],
      // เมนูออกใบสั่งซื้อ
      pos_system: [
        { path: '/arin/pos/productlist', active: '/arin/pos/productlist' },
        { path: '/arin/pos/cartlist', active: '/arin/pos/cartlist' },
        { path: '/arin/pos/productempty', active: '/arin/pos/productempty' },
        { path: '/arin/pos/myorderlist', active: '/arin/pos/myorderlist' },
        { path: '/arin/pos/posSupplier', active: '/arin/pos/posSupplier' },
        { path: '/arin/pos/AddposSupplier', active: '/arin/pos/AddposSupplier' },
        { path: '/arin/pos/editposSupplier/' + this.$route.params.id, active: '/arin/pos/editposSupplier/' + this.$route.params.id },
        { path: '/arin/pos/posdebtbalancelist', active: '/arin/pos/posdebtbalancelist' },
        { path: '/arin/pos/posdebtbalancepay', active: '/arin/pos/posdebtbalancepay' },
        { path: '/arin/pos/posdebtbalancepaybank', active: '/arin/pos/posdebtbalancepaybank' },
        { path: '/arin/pos/posdebtbalancepayhistory', active: '/arin/pos/posdebtbalancepayhistory' },
        { path: '/arin/pos/posdebtbalancedetail', active: '/arin/pos/posdebtbalancedetail' },

        { path: '/arin/pos/productSettinglist' },
        { path: '/arin/pos/countingstocklist' },
        { path: '/arin/pos/countingstockcheck' },
        { path: '/arin/pos/countingstockcreate' },
        { path: '/arin/pos/countingstockedit/' + this.$route.params.id },
        { path: '/arin/pos/countingstockdetail/' + this.$route.params.id },
        { path: '/arin/pos/countingstockcount' },
        { path: '/arin/pos/warehouseproductlist' },
        { path: '/arin/pos/addproductdata', },
        { path: '/arin/pos/chooseproduct' },
        { path: '/arin/pos/printbarcode' },
        { path: '/arin/pos/promotionlist' },
        { path: '/arin/pos/editpromotion/' + this.$route.params.id },
        { path: '/arin/pos/addpromotion' },
        { path: '/arin/pos/addpromotionnew' },
        { path: '/arin/pos/detailpromotion/' + this.$route.params.id },
        { path: '/arin/pos/detailpromotionnew/' + this.$route.params.id },
        { path: '/arin/pos/editpromotionnew/' + this.$route.params.id },
        { path: '/arin/pos/returnproductlist' },
        { path: '/arin/pos/warehouseall' },
        { path: '/arin/pos/bestsellall' },
        { path: '/arin/pos/bestsellproduct/' + this.$route.params.id  },
        { path: '/arin/pos/transfergoods' },
        { path: '/arin/pos/transfergoodsreceived' },
        { path: '/arin/pos/transfergoodsadd' },
        { path: '/arin/pos/transfergoodsedit/' + this.$route.params.id},
        { path: '/arin/pos/transfergoodsdetail/' + this.$route.params.id},
        { path: '/arin/pos/returnproductadd' },
        { path: '/arin/pos/returnproductdetail' },
        { path: '/arin/pos/stocksearch' },
        { path: '/arin/pos/inventoryreport' },
        { path: '/arin/pos/inventorylist' },
        { path: '/arin/pos/inventorydetail/' + this.$route.params.id },
        { path: '/arin/pos/historyimportinventory' },
        { path: '/arin/pos/inventoryadd' },
        { path: '/arin/pos/detailproductdata/' + this.$route.params.id },
        { path: '/arin/pos/editproductdata/' + this.$route.params.id },
        { path: '/arin/pos/historyimportinventorydetail/' + this.$route.params.id },
        { path: '/arin/pos/posrecallbill/' + this.$route.params.id },
        { path: '/arin/pos/exportproduct' },
        { path: '/arin/pos/exportproductdetail' },
        { path: '/arin/pos/searchexpireproduct' },
        { path: '/arin/pos/printbarcodeonshelf' },
       

        { path: '/arin/pos/openpos' },
        { path: '/arin/pos/customerpointlist' },
        { path: '/arin/pos/addcustomerpoint' },
        { path: '/arin/pos/detailcustomerpoint/' + this.$route.params.id },
        { path: '/arin/pos/editcustomerpoint/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestax' },
        { path: '/arin/pos/posinvoicestaxadd/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxadd' },
        { path: '/arin/pos/posinvoicestaxdetail/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxrefund' },
        { path: '/arin/pos/posinvoicestaxrefundadd' },
        { path: '/arin/pos/posinvoicestaxrefundadd/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxrefundedit/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxrefunddetail/' + this.$route.params.id },
        { path: '/arin/pos/posbillafter' },
        { path: '/arin/pos/posbillsale/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicesclosesummary/' + this.$route.params.id },
        { path: '/arin/pos/possalereport' },
        { path: '/arin/pos/possalehistory' + this.$route.params.id  },
        { path: '/arin/pos/possalereportround/' + this.$route.params.id },
        { path: '/arin/pos/inventoryedit/' + this.$route.params.id },



      ],
      itemsProduct: [
        { menu: 'สั่งซื้อสินค้า', href: '/arin/pos/productlist' },
        { menu: 'คำสั่งซื้อของฉัน', href: '/arin/pos/myorderlist' },
        { menu: 'ยอดหนี้ของฉัน', href: '/arin/pos/posdebtbalancelist' },
        { menu: 'ซัพพลายเออร์', href: '/arin/pos/posSupplier' },
      ],
      // เมนูคลังสินค้า
      warehouse: [
        { path: '/arin/pos/productlist' },
        { path: '/arin/pos/cartlist' },
        { path: '/arin/pos/productempty' },
        { path: '/arin/pos/myorderlist' },
        { path: '/arin/pos/posSupplier' },
        { path: '/arin/pos/AddposSupplier' },
        { path: '/arin/pos/editposSupplier/' + this.$route.params.id },
        { path: '/arin/pos/posdebtbalancelist' },
        { path: '/arin/pos/posdebtbalancepay' },
        { path: '/arin/pos/posdebtbalancepaybank' },
        { path: '/arin/pos/posdebtbalancepayhistory' },
        { path: '/arin/pos/posdebtbalancedetail' },



        { path: '/arin/pos/productSettinglist', active: '/arin/pos/productSettinglist' },
        { path: '/arin/pos/countingstocklist', active: '/arin/pos/countingstocklist' },
        { path: '/arin/pos/countingstockcheck', active: '/arin/pos/countingstockcheck' },
        { path: '/arin/pos/countingstockcreate', active: '/arin/pos/countingstockcreate' },
        { path: '/arin/pos/countingstockedit/' + this.$route.params.id, active: '/arin/pos/countingstockedit/' + this.$route.params.id },
        { path: '/arin/pos/countingstockdetail/' + this.$route.params.id, active: '/arin/pos/countingstockdetail/' + this.$route.params.id },
        { path: '/arin/pos/countingstockcount', active: '/arin/pos/countingstockcount' },
        { path: '/arin/pos/warehouseproductlist', active: '/arin/pos/warehouseproductlist' },
        { path: '/arin/pos/addproductdata', active: '/arin/pos/addproductdata' },
        { path: '/arin/pos/chooseproduct', active: '/arin/pos/chooseproduct' },
        { path: '/arin/pos/printbarcode', active: '/arin/pos/printbarcode' },
        { path: '/arin/pos/promotionlist', active: '/arin/pos/promotionlist' },
        { path: '/arin/pos/editpromotion/' + this.$route.params.id, active: '/arin/pos/editpromotion/' + this.$route.params.id },
        { path: '/arin/pos/addpromotion', active: '/arin/pos/addpromotion' },
        { path: '/arin/pos/addpromotionnew', active: '/arin/pos/addpromotionnew' },
        { path: '/arin/pos/detailpromotion/' + this.$route.params.id, active: '/arin/pos/detailpromotion/' + this.$route.params.id },
        { path: '/arin/pos/detailpromotionnew/' + this.$route.params.id, active: '/arin/pos/detailpromotionnew/' + this.$route.params.id },
        { path: '/arin/pos/editpromotionnew/' + this.$route.params.id, active: '/arin/pos/editpromotionnew/' + this.$route.params.id },
        { path: '/arin/pos/returnproductlist', active: '/arin/pos/returnproductlist' },
        { path: '/arin/pos/warehouseall', active: '/arin/pos/warehouseall' },
        { path: '/arin/pos/bestsellall', active: '/arin/pos/bestsellall' },       
        { path: '/arin/pos/bestsellproduct/' + this.$route.params.id , active: '/arin/pos/bestsellproduct/' + this.$route.params.id  },       
        { path: '/arin/pos/transfergoods', active: '/arin/pos/transfergoods' },   
        { path: '/arin/pos/transfergoodsreceived', active: '/arin/pos/transfergoodsreceived' },
        { path: '/arin/pos/transfergoodsadd', active: '/arin/pos/transfergoodsadd' },       
        { path: '/arin/pos/transfergoodsedit/' + this.$route.params.id, active: '/arin/pos/transfergoodsedit/' + this.$route.params.id},       
        { path: '/arin/pos/transfergoodsdetail/' + this.$route.params.id, active: '/arin/pos/transfergoodsdetail/' + this.$route.params.id},       
        { path: '/arin/pos/returnproductadd', active: '/arin/pos/returnproductadd' },
        { path: '/arin/pos/returnproductdetail', active: '/arin/pos/returnproductdetail' },
        { path: '/arin/pos/stocksearch', active: '/arin/pos/stocksearch' },
        { path: '/arin/pos/inventoryreport', active: '/arin/pos/inventoryreport' },
        { path: '/arin/pos/inventorylist', active: '/arin/pos/inventorylist' },
        { path: '/arin/pos/inventorydetail/' + this.$route.params.id, active: '/arin/pos/inventorydetail/' + this.$route.params.id },
        { path: '/arin/pos/historyimportinventory', active: '/arin/pos/historyimportinventory' },
        { path: '/arin/pos/inventoryadd', active: '/arin/pos/inventoryadd' },
        { path: '/arin/pos/detailproductdata/' + this.$route.params.id, active: '/arin/pos/detailproductdata/' + this.$route.params.id },
        { path: '/arin/pos/editproductdata/' + this.$route.params.id, active: '/arin/pos/editproductdata/' + this.$route.params.id },
        { path: '/arin/pos/inventoryedit/' + this.$route.params.id, active: '/arin/pos/inventoryedit/' + this.$route.params.id },
        { path: '/arin/pos/historyimportinventorydetail/' + this.$route.params.id, active: '/arin/pos/historyimportinventorydetail/' + this.$route.params.id },
        { path: '/arin/pos/exportproduct' ,active: '/arin/pos/exportproduct'},
        { path: '/arin/pos/exportproductdetail' ,active: '/arin/pos/exportproductdetail'},
        { path: '/arin/pos/searchexpireproduct' ,active: '/arin/pos/searchexpireproduct'},
        { path: '/arin/pos/printbarcodeonshelf',active: '/arin/pos/printbarcodeonshelf' },


        { path: '/arin/pos/openpos' },
        { path: '/arin/pos/customerpointlist' },
        { path: '/arin/pos/addcustomerpoint' },
        { path: '/arin/pos/detailcustomerpoint/' + this.$route.params.id },
        { path: '/arin/pos/editcustomerpoint/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestax' },
        { path: '/arin/pos/posinvoicestaxadd/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxadd' },
        { path: '/arin/pos/posinvoicestaxdetail/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxrefund' },
        { path: '/arin/pos/posinvoicestaxrefundadd' },
        { path: '/arin/pos/posinvoicestaxrefundadd/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxrefundedit/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxrefunddetail/' + this.$route.params.id },
        { path: '/arin/pos/posbillafter' },
        { path: '/arin/pos/posbillsale/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicesclosesummary/' + this.$route.params.id },
        { path: '/arin/pos/possalereport' },
        { path: '/arin/pos/possalehistory' },        
        { path: '/arin/pos/possalereportround/' + this.$route.params.id },
        { path: '/arin/pos/posrecallbill/' + this.$route.params.id },

      ],

      sub_warehouse_product: [
        { menu: 'ตั้งค่าสินค้า', href: '/arin/pos/productSettinglist' },
        { menu: 'จัดการข้อมูลสินค้า', href: '/arin/pos/warehouseproductlist' },
        { menu: 'พิมพ์บาร์โค๊ด', href: '/arin/pos/printbarcode' },
        { menu: 'พิมพ์บาร์โค๊ดติดชั้น', href: '/arin/pos/printbarcodeonshelf' },
        { menu: 'จัดโปรโมชั่นสินค้า', href: '/arin/pos/promotionlist' },
      ],
      sub_warehouse_stockProduct: [
        { menu: 'คลังสินค้า', href: '/arin/pos/inventorylist' },
        { menu: 'ค้นหาล็อต', href: '/arin/pos/stocksearch' },
        { menu: 'ค้นหาสินค้าใกล้หมดอายุ', href: '/arin/pos/searchexpireproduct' },
        { menu: 'รายการสินค้าออกจากคลัง', href: '/arin/pos/exportproduct' },
        { menu: 'การคืนสินค้า', href: '/arin/pos/returnproductlist' },
        { menu: 'คลังสินค้าทุกสาขา', href: '/arin/pos/warehouseall' },
        { menu: 'สินค้าขายดีของแต่ละสาขา', href: '/arin/pos/bestsellall' },
        { menu: 'โอนสินค้า', href: '/arin/pos/transfergoods' },
        { menu: 'รับสินค้า', href: '/arin/pos/transfergoodsreceived' },
      ],
      // เมนูการขาย
      pos_sale: [
        { path: '/arin/pos/productlist' },
        { path: '/arin/pos/cartlist' },
        { path: '/arin/pos/productempty' },
        { path: '/arin/pos/myorderlist' },
        { path: '/arin/pos/posSupplier' },
        { path: '/arin/pos/AddposSupplier' },
        { path: '/arin/pos/editposSupplier/' + this.$route.params.id },
        { path: '/arin/pos/posdebtbalancelist' },
        { path: '/arin/pos/posdebtbalancepay' },
        { path: '/arin/pos/posdebtbalancepaybank' },
        { path: '/arin/pos/posdebtbalancepayhistory' },
        { path: '/arin/pos/posdebtbalancedetail' },

        { path: '/arin/pos/productSettinglist' },
        { path: '/arin/pos/countingstocklist' },
        { path: '/arin/pos/countingstockcheck' },
        { path: '/arin/pos/countingstockcreate' },
        { path: '/arin/pos/countingstockedit/' + this.$route.params.id },
        { path: '/arin/pos/countingstockdetail/' + this.$route.params.id },
        { path: '/arin/pos/countingstockcount' },
        { path: '/arin/pos/warehouseproductlist' },
        { path: '/arin/pos/addproductdata' },
        { path: '/arin/pos/chooseproduct' },
        { path: '/arin/pos/printbarcode' },
        { path: '/arin/pos/promotionlist' },
        { path: '/arin/pos/editpromotion/' + this.$route.params.id },
        { path: '/arin/pos/addpromotion' },
        { path: '/arin/pos/addpromotionnew' },
        { path: '/arin/pos/detailpromotion/' + this.$route.params.id },
        { path: '/arin/pos/detailpromotionnew/' + this.$route.params.id },
        { path: '/arin/pos/editpromotionnew/' + this.$route.params.id },
        { path: '/arin/pos/returnproductlist' },
        { path: '/arin/pos/warehouseall' },
        { path: '/arin/pos/bestsellall' },
        { path: '/arin/pos/bestsellproduct/' + this.$route.params.id  },
        { path: '/arin/pos/transfergoods' },
        { path: '/arin/pos/transfergoodsreceived' },
        { path: '/arin/pos/transfergoodsadd' },
        { path: '/arin/pos/transfergoodsedit/' + this.$route.params.id},
        { path: '/arin/pos/transfergoodsdetail/' + this.$route.params.id},
        { path: '/arin/pos/returnproductadd' },
        { path: '/arin/pos/returnproductdetail' },
        { path: '/arin/pos/stocksearch' },
        { path: '/arin/pos/inventoryreport' },
        { path: '/arin/pos/inventorylist' },
        { path: '/arin/pos/inventorydetail/' + this.$route.params.id },
        { path: '/arin/pos/historyimportinventory' },
        { path: '/arin/pos/inventoryadd' },
        { path: '/arin/pos/detailproductdata/' + this.$route.params.id },
        { path: '/arin/pos/editproductdata/' + this.$route.params.id },
        { path: '/arin/pos/inventoryedit/' + this.$route.params.id },
        { path: '/arin/pos/historyimportinventorydetail/' + this.$route.params.id },
        { path: '/arin/pos/exportproduct' },
        { path: '/arin/pos/exportproductdetail' },
        { path: '/arin/pos/searchexpireproduct' },
        { path: '/arin/pos/printbarcodeonshelf' },

        { path: '/arin/pos/openpos', active: '/arin/pos/openpos' },
        { path: '/arin/pos/posinvoicestax', active: '/arin/pos/posinvoicestax' },
        { path: '/arin/pos/posinvoicestaxadd/' + this.$route.params.id, active: '/arin/pos/posinvoicestaxadd/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxadd', active: '/arin/pos/posinvoicestaxadd' },
        { path: '/arin/pos/posbillafter', active: '/arin/pos/posbillafter' },
        { path: '/arin/pos/posinvoicestaxrefund', active: '/arin/pos/posinvoicestaxrefund' },
        { path: '/arin/pos/posinvoicestaxrefundadd', active: '/arin/pos/posinvoicestaxrefundadd' },
        { path: '/arin/pos/posinvoicestaxrefundadd/' + this.$route.params.id, active: '/arin/pos/posinvoicestaxrefundadd/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxrefundedit/' + this.$route.params.id, active: '/arin/pos/posinvoicestaxrefundedit/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxrefunddetail/' + this.$route.params.id, active: '/arin/pos/posinvoicestaxrefunddetail/' + this.$route.params.id },
        { path: '/arin/pos/possalereport', active: '/arin/pos/possalereport' },
        { path: '/arin/pos/possalehistory', active: '/arin/pos/possalehistory' },
        { path: '/arin/pos/posinvoicestaxdetail/' + this.$route.params.id, active: '/arin/pos/posinvoicestaxdetail/' + this.$route.params.id },
        { path: '/arin/pos/possalereportround/' + this.$route.params.id, active: '/arin/pos/possalereportround/' + this.$route.params.id },

        { path: '/arin/pos/posrecallbill/' + this.$route.params.id, active: '/arin/pos/posrecallbill/' + this.$route.params.id },

        { path: '/arin/pos/customerpointlist' },
        { path: '/arin/pos/addcustomerpoint' },
        { path: '/arin/pos/detailcustomerpoint/' + this.$route.params.id },
        { path: '/arin/pos/editcustomerpoint/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxdetail' },
        { path: '/arin/pos/posbillsale/' + this.$route.params.id, active: '/arin/pos/posbillsale/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicesclosesummary/' + this.$route.params.id, active: '/arin/pos/posinvoicesclosesummary/' + this.$route.params.id },


      ],
      pos_sub_sale: [
        { menu: 'เปิดรอบการขาย', href: '/arin/pos/openpos' },
        { menu: 'ประวัติการขายสินค้า', href: '/arin/pos/possalehistory' },
        { menu: 'รายการบิลย้อนหลัง', href: '/arin/pos/posbillafter' },
        { menu: 'รายการใบแจ้งหนี้/ใบกำกับภาษี', href: '/arin/pos/posinvoicestax' },
        { menu: 'รายการใบ Tax Refund', href: '/arin/pos/posinvoicestaxrefund' },
        { menu: 'รายงานขาย', href: '/arin/pos/possalereport' },
      ],
      // เมนูการสะสมแต้มลูกค้า
      pos_collection_of_points: [
        { path: '/arin/pos/productlist' },
        { path: '/arin/pos/cartlist' },
        { path: '/arin/pos/productempty' },
        { path: '/arin/pos/myorderlist' },
        { path: '/arin/pos/posSupplier' },
        { path: '/arin/pos/AddposSupplier' },
        { path: '/arin/pos/editposSupplier/' + this.$route.params.id },
        { path: '/arin/pos/posdebtbalancelist' },
        { path: '/arin/pos/posdebtbalancepay' },
        { path: '/arin/pos/posdebtbalancepaybank' },
        { path: '/arin/pos/posdebtbalancepayhistory' },
        { path: '/arin/pos/posdebtbalancedetail' },
        { path: '/arin/pos/exportproduct' },
        { path: '/arin/pos/exportproductdetail' },
        { path: '/arin/pos/searchexpireproduct' },
        { path: '/arin/pos/printbarcodeonshelf' },
       

        { path: '/arin/pos/productSettinglist' },
        { path: '/arin/pos/countingstocklist' },
        { path: '/arin/pos/countingstockcheck' },
        { path: '/arin/pos/countingstockcreate' },
        { path: '/arin/pos/countingstockedit/' + this.$route.params.id },
        { path: '/arin/pos/countingstockdetail/' + this.$route.params.id },
        { path: '/arin/pos/countingstockcount' },
        { path: '/arin/pos/warehouseproductlist' },
        { path: '/arin/pos/addproductdata' },
        { path: '/arin/pos/chooseproduct' },
        { path: '/arin/pos/printbarcode' },
        { path: '/arin/pos/promotionlist' },
        { path: '/arin/pos/editpromotion/' + this.$route.params.id },
        { path: '/arin/pos/addpromotion' },
        { path: '/arin/pos/addpromotionnew' },
        { path: '/arin/pos/detailpromotion/' + this.$route.params.id },
        { path: '/arin/pos/detailpromotionnew/' + this.$route.params.id },
        { path: '/arin/pos/editpromotionnew/' + this.$route.params.id },
        { path: '/arin/pos/returnproductlist' },
        { path: '/arin/pos/warehouseall' },
        { path: '/arin/pos/bestsellall' },
        { path: '/arin/pos/bestsellproduct/' + this.$route.params.id  },
        { path: '/arin/pos/transfergoods' },
        { path: '/arin/pos/transfergoodsreceived' },
        { path: '/arin/pos/transfergoodsadd' },
        { path: '/arin/pos/transfergoodsedit/' + this.$route.params.id},
        { path: '/arin/pos/transfergoodsdetail/' + this.$route.params.id},
        { path: '/arin/pos/returnproductadd' },
        { path: '/arin/pos/returnproductdetail' },
        { path: '/arin/pos/stocksearch' },
        { path: '/arin/pos/inventoryreport' },
        { path: '/arin/pos/inventorylist' },
        { path: '/arin/pos/inventorydetail/' + this.$route.params.id },
        { path: '/arin/pos/historyimportinventory' },
        { path: '/arin/pos/inventoryadd' },
        { path: '/arin/pos/posinvoicestax' },
        { path: '/arin/pos/posinvoicestaxadd/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxadd' },
        { path: '/arin/pos/posinvoicestaxdetail/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxrefund' },
        { path: '/arin/pos/posinvoicestaxrefundadd' },
        { path: '/arin/pos/posinvoicestaxrefundadd/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxrefundedit/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicestaxrefunddetail/' + this.$route.params.id },
        { path: '/arin/pos/posbillafter' },
        { path: '/arin/pos/posbillsale/' + this.$route.params.id },
        { path: '/arin/pos/posinvoicesclosesummary/' + this.$route.params.id },
        { path: '/arin/pos/possalereport' },
        { path: '/arin/pos/possalehistory' },
        { path: '/arin/pos/possalereportround/' + this.$route.params.id },
        { path: '/arin/pos/openpos' },
        { path: '/arin/pos/detailproductdata/' + this.$route.params.id },
        { path: '/arin/pos/editproductdata/' + this.$route.params.id },
        { path: '/arin/pos/inventoryedit/' + this.$route.params.id },
        { path: '/arin/pos/historyimportinventorydetail/' + this.$route.params.id },
        { path: '/arin/pos/posrecallbill/' + this.$route.params.id },

        { path: '/arin/pos/customerpointlist', active: '/arin/pos/customerpointlist' },
        { path: '/arin/pos/addcustomerpoint', active: '/arin/pos/addcustomerpoint' },
        { path: '/arin/pos/detailcustomerpoint/' + this.$route.params.id, active: '/arin/pos/detailcustomerpoint/' + this.$route.params.id },
      ],

      right: null,
      input_set: [],
    }
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer; // เปิด-ปิด Navigation Drawer
    },
    toggleDrawerMobile() {
      this.drawerMobile = !this.drawerMobile; // เปิด-ปิด Navigation Drawer Mobile
    },
    switch_page(link) {
      // this.switch_page(link)
      this.$store.commit("tabs", 1);
      window.location.href = link;

    },

    async logout() {
      await Swal.fire({
        title: 'คุณต้องการออกจากระบบหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed === true) {
          this.$store.commit('store_arin/logout_success') /
            this.switch_page('/arin/login')
        }
      });
    },

    getShow_api() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };

      HTTP_ARIN.get("/profile/detail", config).then((res) => {
        if (res.data.successful === true) {
          // ถ้า login มาจาก customer (เจ้าของร้าน)
          if (res.data.ProfileDetail) {
            const userData = {
              access_token: this.$store.state.store_arin.access_token,
              user_data: res.data.ProfileDetail,
              status_permission: res.data.ProfileDetail_type,
            };
            this.$store.commit("store_arin/login_success", userData);
          }

          // ถ้า login มาจาก employee (พนักงาน)
          else if (res.data.ProfileDetail_emp) {
            const userData = {
              access_token: this.$store.state.store_arin.access_token,
              user_data: res.data.ProfileDetail_emp,
              status_permission: res.data.ProfileDetail_emp_type,
            };
            this.$store.commit("store_arin/login_success", userData);
          }
        }
      });


      let store_id = this.$store.state.store_arin.user_data.store_id;
      let emp_type = this.$store.state.store_arin.status_permission;
      HTTP_ARIN.get('/stores/detail/' + store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.input_set = res.data.storeDetail;
          this.input_set.check_emp = emp_type;
          if (this.input_set.store_name == null) {
            this.$router.push('/arin/setting')
          }
        }
      })
    },

  },
  mounted() {
    this.itemsProduct = this.$store.state.store_arin.user_data.status_main_store == 1 ?
[
        { menu: 'สั่งซื้อสินค้า', href: '/arin/pos/productlist' },
        { menu: 'คำสั่งซื้อของฉัน', href: '/arin/pos/myorderlist' },
        // { menu: 'ยอดหนี้ของฉัน', href: '/arin/pos/posdebtbalancelist' },
        { menu: 'ซัพพลายเออร์', href: '/arin/pos/posSupplier' },
      ]
      :
      this.$store.state.store_arin.user_data.customer_type == 2 ?
      [
        { menu: 'สั่งซื้อสินค้า', href: '/arin/pos/productlist' },
        { menu: 'คำสั่งซื้อของฉัน', href: '/arin/pos/myorderlist' },
        { menu: 'ยอดหนี้ของฉัน', href: '/arin/pos/posdebtbalancelist' },
        { menu: 'ซัพพลายเออร์', href: '/arin/pos/posSupplier' },
      ]
      : 
      [
        { menu: 'สั่งซื้อสินค้า', href: '/arin/pos/productlist' },
        { menu: 'คำสั่งซื้อของฉัน', href: '/arin/pos/myorderlist' },
        { menu: 'ซัพพลายเออร์', href: '/arin/pos/posSupplier' },
      ];
    this.getShow_api()
  }
}
</script>

<style scoped>
.v-list {
  border-top: 4px solid #D6BFAF;
}

.v-list-item:hover,
.v-list-item__title:hover {
  background: rgba(214, 191, 175, 0.05);
  color: #D6BFAF;
}

.v-app-bar__nav-icon {
  display: none;
}

.nav-header {
  padding: 8px 15px 8px 15px;
  cursor: pointer;
}

.nav-header.active {
  background: linear-gradient(90deg, #B0886B 0%, rgba(214, 191, 175, 0) 100%), #D6BFAF;
  border-radius: 10px;
}

.nav-items {
  gap: 8px;
}

span.nav-item-title {
  font-size: 16px;
}

.nav-header.active span.nav-item-title {
  color: #FFF;
}

.nav-header span.nav-item-title {
  color: #616A6B;
}

.profile_user {
  width: 46px;
}

.profile_user>img {
  max-width: 46px;
}

.user_name {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.user_role {
  color: #909090;
  font-weight: 500;
  font-size: 14px;
}

/* Navbar */
.navigation_bg {
  background-color: #e7dcd4;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.card_logo {
  background: #FFFFFF;
  border-radius: 50%;
  padding: 6px;
}

.logo_list {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo_list>.logo {
  width: 36px;
}

.logo_list>.logo>img {
  max-width: 100%;
}

.border-bottom-logo {
  border-bottom: 1px #909090 solid;
}

.menu-logo {
  margin-bottom: 20px;
}

.meun-list {
  margin-bottom: 16px;
}



.meun-list:hover {
  background: #FFFFFF;
  transition: 0.1s !important;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.meun-list.router-link-active {
  background: #FFFFFF;
  transition: 0.1s !important;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.v-menu__content {
  /* left: 500px !important; */
}



@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .user_account {
    padding-left: 0;
  }


  .v-navigation-drawer.pc {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .v-main {
    padding: 0 !important;
  }

  .v-app-bar {
    left: 0 !important;
    right: 0 !important;
  }

  .v-navigation-drawer.pc {
    display: none;
  }

  .v-app-bar__nav-icon {
    display: block;
  }

  .profile_user>img {
    max-width: 36px;
  }

  .profile_user {
    width: auto;
  }


  .nav-header {
    display: none;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .profile_user>img {
    max-width: 42px;
  }

  span.nav-item-title,
  .nav-header {
    font-size: 14px;
  }

}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {}


@media only screen and (min-width: 1265px) AND (max-width: 1904px) {}
</style>


